import React from 'react';
import Icon from '../../../components/AppIcon';

const TerminalHeader = () => {
  return (
    <div className="mb-6 md:mb-8 lg:mb-10">
      <div className="flex items-center justify-center gap-3 md:gap-4 mb-4 md:mb-6">
        <div className="w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 bg-primary/20 rounded-sm flex items-center justify-center border-2 border-primary shadow-glow-cyan-md">
          <Icon name="Zap" size={32} color="var(--color-primary)" className="md:w-10 md:h-10 lg:w-12 lg:h-12" />
        </div>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold neon-text-cyan">
          CyberOddEven
        </h1>
      </div>
      
      <div className="text-center space-y-2 md:space-y-3">
        <p className="text-base md:text-lg lg:text-xl font-caption text-primary tracking-wider">
          &gt; SYSTEM ACCESS TERMINAL
        </p>
        <p className="text-xs md:text-sm lg:text-base font-body text-muted-foreground max-w-md mx-auto px-4">
          Enter your credentials to access the psychological gaming arena
        </p>
      </div>

      {/* Terminal decoration */}
      <div className="mt-4 md:mt-6 flex items-center justify-center gap-2">
        <div className="w-2 h-2 bg-accent rounded-sm shadow-glow-green-sm animate-pulse" />
        <div className="w-2 h-2 bg-warning rounded-sm shadow-glow-cyan-sm animate-pulse" style={{ animationDelay: '0.5s' }} />
        <div className="w-2 h-2 bg-error rounded-sm shadow-glow-magenta-sm animate-pulse" style={{ animationDelay: '1s' }} />
      </div>
    </div>
  );
};

export default TerminalHeader;